/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Error_CodeInputs */

const en_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const fr_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const de_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const it_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const ru_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const es_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const zh_cn2_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const ja_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const hi_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

const pt_pt2_offline_error_code = /** @type {(inputs: Offline_Error_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404`)
};

/**
* | output |
* | --- |
* | "404" |
*
* @param {Offline_Error_CodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_error_code = /** @type {((inputs?: Offline_Error_CodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Error_CodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_error_code(inputs)
	if (locale === "de") return de_offline_error_code(inputs)
	if (locale === "it") return it_offline_error_code(inputs)
	if (locale === "ru") return ru_offline_error_code(inputs)
	if (locale === "es") return es_offline_error_code(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_error_code(inputs)
	if (locale === "ja") return ja_offline_error_code(inputs)
	if (locale === "hi") return hi_offline_error_code(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_error_code(inputs)
	return en_offline_error_code(inputs)
});